import React, { useCallback, useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { ModalManager, useModalContext } from '@bcraft-frontend-lib/core'
import { SetSlotsContextState, SLOTS_MODAL_URLS, SlotsProvider } from '@bcraft-frontend-lib/slots'

import { projectDomainName } from 'shared/constants'
import { getCurrencySymbol } from 'shared/constants/currencies/getCurrencySymbol'

import { selectIsUserAuthenticated, selectUserCurrency, selectUserData } from 'features/auth/selectors'
import { selectLanguage } from 'features/userSettings/selectors'

import Modal from 'components/Modal/Modal'

import { addNotify } from 'components/Notify'
import { Spinner } from 'components/Spinner'

export const AppProvider: React.FC = ({ children }) => {
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const user = useSelector(selectUserData, shallowEqual)
  const currency = useSelector(selectUserCurrency, shallowEqual)
  const lang = useSelector(selectLanguage, shallowEqual)
  const { pushNewModal } = useModalContext()

  const currencySymbol = useMemo(() => getCurrencySymbol(currency), [currency])

  const handleOpenFreeSpinEndModal = useCallback<Required<SetSlotsContextState>['handleOpenFreeSpinEndModal']>(
    slotId => {
      pushNewModal(SLOTS_MODAL_URLS.FREE_SPIN_END(slotId))()
    },
    [pushNewModal],
  )

  return (
    <SlotsProvider
      isAuth={isAuth}
      lang={lang}
      currencySymbol={currencySymbol}
      user={user}
      addNotify={addNotify}
      Loader={<Spinner isLoading />}
      handleOpenFreeSpinEndModal={handleOpenFreeSpinEndModal}
      newProvidersList={[]}
      proxy={projectDomainName}>
      <React.Suspense fallback={<div>Loading...</div>}>
        <ModalManager
          renderModal={({ isOpen, onClose, path, renderComponent, customProps }) => (
            <Modal key={path} open={isOpen} handleClose={onClose} {...customProps}>
              {renderComponent({ path })}
            </Modal>
          )}
        />
      </React.Suspense>

      {children}
    </SlotsProvider>
  )
}